import { queryOptions } from '@tanstack/react-query';

import { resolveRangeFrom } from '@/features/stats/range';
import { api, unwrap } from '@/shared/api/client';

export const dashboardQueryOptions = () =>
  queryOptions({
    queryKey: ['dashboard'],
    queryFn: ({ signal }) => unwrap(api.GET('/api/dashboard', { signal })),
  });

/** 홈의 최근 30일 매출 차트 조건 — 로더와 화면이 같은 캐시 키를 쓰도록 한 곳에서 만든다 */
export function homeRevenueTrendParams() {
  return { unit: 'day' as const, from: resolveRangeFrom('day', '30d') };
}
